import { useEffect, useState } from "react";

export default function KnowledgeHero() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 80);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="relative pt-20 bg-[#1e1a16] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=ancient%20Tibetan%20manuscripts%20scrolls%20natural%20crystals%20jade%20artifacts%20arranged%20on%20aged%20wooden%20table%20warm%20golden%20candlelight%20atmospheric%20cultural%20heritage%20documentary%20photography%20serene%20scholarly&width=1920&height=700&seq=know_hero001&orientation=landscape"
          alt="能量文化知識專欄"
          className="w-full h-full object-cover object-center opacity-35"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#1e1a16]/50 via-[#1e1a16]/40 to-[#1e1a16]"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-16 pt-20 pb-20 text-center">
        <div
          className={`transition-all duration-1000 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <div className="flex items-center justify-center gap-3 mb-5">
            <span className="w-10 h-px bg-[#c9a96e]"></span>
            <span
              className="text-[#c9a96e] text-[1rem] tracking-[0.35em] font-medium"
              style={{ fontFamily: "'Noto Serif TC', serif" }}
            >
              KNOWLEDGE
            </span>
            <span className="w-10 h-px bg-[#c9a96e]"></span>
          </div>
          <h1
            className="text-white font-bold mb-5 leading-[1.3]"
            style={{
              fontSize: "clamp(2rem, 4vw, 2.75rem)",
              fontFamily: "'Noto Serif TC', serif",
            }}
          >
            認識能量文化
          </h1>
          <p
            className="text-white/60 max-w-xl mx-auto leading-[1.75]"
            style={{
              fontSize: "1.1875rem",
              fontFamily: "'Noto Serif TC', serif",
            }}
          >
            深入了解東方能量文化的智慧與傳承，探索每一種材質背後的故事與意義。
          </p>
        </div>
      </div>
    </section>
  );
}
